import { makeStyles, mergeClasses, shorthands, tokens, typographyStyles } from '@fluentui/react-components';
import type { SensitivityLabelSlots, SensitivityLabelState } from './SensitivityLabel.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const sensitivityLabelClassNames: SlotClassNames<SensitivityLabelSlots> = {
  root: 'fai-SensitivityLabel',
  label: 'fai-SensitivityLabel__label',
  tooltip: 'fai-SensitivityLabel__tooltip',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {},
  label: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: tokens.lineHeightBase300,
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    color: tokens.colorNeutralForeground3,
    backgroundColor: tokens.colorNeutralBackground5,
    ...typographyStyles.caption2Strong,
    ...shorthands.padding(0, tokens.spacingHorizontalSNudge),
  },
  tooltip: {},
});

/**
 * Apply styling to the SensitivityLabel slots based on the state
 */
export const useSensitivityLabelStyles_unstable = (state: SensitivityLabelState): SensitivityLabelState => {
  const styles = useStyles();
  state.root.className = mergeClasses(sensitivityLabelClassNames.root, styles.root, state.root.className);

  if (state.label) {
    state.label.className = mergeClasses(sensitivityLabelClassNames.label, styles.label, state.label.className);
  }

  if (state.tooltip) {
    state.tooltip.className = mergeClasses(sensitivityLabelClassNames.tooltip, styles.tooltip, state.tooltip.className);
  }

  return state;
};
